import { isEmpty } from 'lodash';

/**
 * The address of a registration — one household on one address, so it lives
 * on the registration and not on the person block.
 */
export const getRegistrationAddress = (
  value:
    | {
        street?: string | null | undefined;
        houseNumber?: string | null | undefined;
        houseNumberAddition?: string | null | undefined;
        postalCode?: string | null | undefined;
        city?: string | null | undefined;
      }
    | null
    | undefined
): string => {
  if (!value) {
    return '';
  }

  const street = [
    value.street,
    [value.houseNumber, value.houseNumberAddition]
      .filter(option => !isEmpty(option))
      .join(''),
  ]
    .filter(option => !isEmpty(option))
    .join(' ');

  const place = [value.postalCode, value.city]
    .filter(option => !isEmpty(option))
    .join(' ');

  return [street, place].filter(option => !isEmpty(option)).join(', ');
};
